module.exports = __webpack_public_path__ + "static/media/anatomia.61ea5986.png";